import { Validators } from '@biteinc/common';
import { ItemTaxationStatusHelper } from '@biteinc/enums';
/**
 * Schema for the ordered item as it appears in the database.
 * Note that this schema differs from the request schema.
 */
export const orderedItemDbSchema = {
    displayName: 'ordered item db',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
        },
        orderedItemId: {
            type: 'mongoId',
            isPermanent: true,
        },
        posId: {
            type: 'keyString',
            isPermanent: true,
        },
        i9nId: {
            type: 'keyString',
            isPermanent: true,
        },
        name: {
            type: 'shortString',
            required: true,
            isPermanent: true,
        },
        posName: {
            type: 'shortString',
            isPermanent: true,
        },
        fulfillmentName: {
            type: 'shortString',
        },
        integrationId: {
            type: 'mongoId',
            isPermanent: true,
        },
        autoAddedByPromotionId: {
            type: 'mongoId',
        },
        isRetail: {
            type: 'bool',
            isPermanent: true,
        },
        scannedBarcode: {
            type: 'keyString',
            validationRegex: Validators.barcodeRegexString,
            isPermanent: true,
        },
        vendor: {
            type: 'object',
            isPermanent: true,
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                },
                name: {
                    type: 'shortString',
                    required: true,
                },
            },
        },
        section: {
            type: 'object',
            isPermanent: true,
            required: true,
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                },
                posId: {
                    type: 'keyString',
                },
                internalName: {
                    type: 'shortString',
                },
                fulfillmentName: {
                    type: 'shortString',
                },
                name: {
                    type: 'shortString',
                    required: true,
                },
                posName: {
                    type: 'shortString',
                },
            },
        },
        taxationStatus: {
            type: 'int',
            values: ItemTaxationStatusHelper.allValuesForMenuItems(),
            isPermanent: true,
        },
        prepTimeMinutes: {
            type: 'int',
            min: 0,
            max: 1440,
            isPermanent: true,
        },
        specialRequest: {
            type: 'keyString',
            validationRegex: Validators.simpleStringRegexString({
                allowCommas: true,
                allowDiacritics: true,
            }),
            // char limitations: no special characters in case we need to print it
        },
        instructions: {
            type: 'keyString',
        },
        recipientName: {
            type: 'keyString',
        },
        recipientNumber: {
            type: 'int',
        },
        i9nComboId: {
            type: 'keyString',
        },
        i9nComboName: {
            type: 'keyString',
        },
        i9nComboPrice: {
            type: 'price',
        },
        i9nTaxProfileId: {
            type: 'keyString',
        },
        posFields: {
            type: 'object',
            isFreeform: true,
        },
        upsellScreen: {
            type: 'shortString',
        },
        priceOption: {
            type: 'object',
            subtype: 'OrderedPriceOptionDb',
            required: true,
        },
    },
};
//# sourceMappingURL=ordered_item_db_schema.js.map